import { apiEndpoint } from './api.js';
import { userObj } from '../stores/authUserStore.js';
import { get } from 'svelte/store';
import { fetchWithCredentials } from './fetchWithCredentials.js';
import { sessionId, csrfTokenStore } from '../stores/sessionStore.js';
import { createAxiosInstance } from './axiosInstance.js';

const AUTH_CHECK_LEASE_KEY = 'dcine.authCheckLeaseUntil';
const AUTH_CHECK_BACKOFF_KEY = 'dcine.authCheckBackoffUntil';
const AUTH_CHECK_MIN_INTERVAL_MS = 60000;
let authCheckFailures = 0;

function storageNumber(key) {
	if (typeof window === 'undefined') return 0;
	try {
		const value = Number(window.localStorage.getItem(key) || 0);
		return Number.isFinite(value) ? value : 0;
	} catch (_error) {
		return 0;
	}
}

function setStorageNumber(key, value) {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(key, String(value));
	} catch (_error) {
		// Continue without cross-tab coordination when storage is unavailable.
	}
}

export async function authCheck(force = false) {
	let url = '/dcns/logincheck/';
	const now = Date.now();
	if (!force && typeof window !== 'undefined') {
		if (storageNumber(AUTH_CHECK_BACKOFF_KEY) > now) return false;
		if (storageNumber(AUTH_CHECK_LEASE_KEY) > now) return false;
	}
	setStorageNumber(AUTH_CHECK_LEASE_KEY, now + AUTH_CHECK_MIN_INTERVAL_MS);
	// use axios to fetch the url as json
	try {
		const ai = createAxiosInstance();
		const response = await ai.get(url);
		const data = response.data;

		const _userObj = get(userObj);

		const csrfToken = document.cookie.replace(/(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/, '$1');
		const currentCsrfToken = get(csrfTokenStore);
		if (csrfToken !== currentCsrfToken) {
			// console.log('csrfToken = ' + csrfToken, 'csrfToken updated.');
			csrfTokenStore.set(csrfToken);
		}

		if (data.Authenticated !== _userObj.Authenticated ||
			data.AccessGroup !== _userObj.AccessGroup ||
			data.regional_codes !== _userObj.regional_codes) {
			// console.log('authService.check -> NOT EQUAL, send LoginEvent');
			// console.log('Authenticated = ' + data.Authenticated, 'usrObj updated.');
			userObj.set(data);
		}
		authCheckFailures = 0;
		setStorageNumber(AUTH_CHECK_BACKOFF_KEY, 0);
		return true;
	} catch (error) {
		authCheckFailures += 1;
		const retryAfterSeconds = Number(error.response?.headers?.['retry-after'] || 0);
		const retryDelayMs = retryAfterSeconds > 0
			? retryAfterSeconds * 1000
			: Math.min(5 * 60 * 1000, 30000 * (2 ** Math.min(authCheckFailures - 1, 4)));
		setStorageNumber(AUTH_CHECK_BACKOFF_KEY, Date.now() + retryDelayMs);
		const status = error.response?.status;
		if (status === 503 || !error.response) {
			console.warn(`Auth check temporarily unavailable; retrying after ${Math.round(retryDelayMs / 1000)} seconds.`);
		} else {
			console.error(`Auth check failed with HTTP ${status}.`);
		}
		return false;
	}
}

export async function DoLogin(username, password) {
	console.log('auth.DoLogin()');
	//
	let url = `${apiEndpoint}/dcns/auth-session/`;
	//
	const response = await fetchWithCredentials(url, {
		method: 'POST',
		body: JSON.stringify({ username: username, password: password }),
		headers: {
			'Content-Type': 'application/json'
		}
	});

	const data = await response.json();

	if (response.ok && data.status === 'success') {
		sessionId.set(data.sessionId);
		let check_res = await authCheck(true);
		const _userObj = get(userObj);
		console.log('authService.DoLogin -> UserObj: ' + JSON.stringify(_userObj));
		// dispatch a login event
		dispatchEvent(new CustomEvent('LoginEvent'));
		return data;
	} else {
		console.log('authService.DoLogin -> Login failed');
		return data;
	}
}

export async function DoLogout() {
	console.log('auth.DoLogout()');
	//
	let url = `${apiEndpoint}/dcns/auth-session/`;
	//
	const response = await fetchWithCredentials(url, {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json'
		},
		credentials: 'include'
	});

	const data = await response.json();
	await authCheck(true);
	const _userObj = get(userObj);
	console.log('authService.DoLogout -> UserObj: ' + JSON.stringify(_userObj));


	// $rootScope.$broadcast('LoginEvent');
}
